// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"37b1241f","977":"2acd0cf8"}[chunkId] + ".chunk.js";
};